import { render } from "./ExpenseTable.vue?vue&type=template&id=24f5e56e&scoped=true&ts=true"
import script from "./ExpenseTable.vue?vue&type=script&lang=ts"
export * from "./ExpenseTable.vue?vue&type=script&lang=ts"

import "./ExpenseTable.vue?vue&type=style&index=0&id=24f5e56e&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f5e56e"]])

export default __exports__